import {request} from "./request";

export function login() {
  return request({
    url: '/user/login',
    data:{
      "passWord": "123456",
      "userName": "123456789"
    }
  })
}

export function getHomeData(token) {
  return request({
    url: '/user/mainView'
  },token)
}

export function harvestWorkpiece(token) {
  return request({
    url: '/user/harvest'
  },token)
}

